'use client';

import { useSearchParams } from 'next/navigation';
import { env } from 'next-runtime-env';

import { DEBUG_TRANSLATION } from '@cookies/Constants/Cookie.constants';
import { isWindowDefined } from '@core/Constants/Window';

import PhraseAppInContextScript from './PhraseAppInContextScript';

const PhraseAppInContextWrapper = ({ projectId }: { projectId: string }) => {
  const searchParams = useSearchParams();
  //NOTE: 'production' as a value is deprecated but still used by PP and maybe PPP
  const isProd =
    env('NEXT_PUBLIC_APP_ENV') === 'prod' || env('NEXT_PUBLIC_APP_ENV') === 'production';

  const search = searchParams.get(DEBUG_TRANSLATION);
  if (!isWindowDefined || isProd || search !== 'on') return null;
  return <PhraseAppInContextScript projectId={projectId} />;
};

export default PhraseAppInContextWrapper;
